import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { SelfDiagnosticStepModel } from './model';

export const adapter: EntityAdapter<SelfDiagnosticStepModel> = createEntityAdapter<SelfDiagnosticStepModel>({
  selectId: model => model.id,
});

export interface SelfDiagnosticStepState extends EntityState<SelfDiagnosticStepModel> {
  selected: SelfDiagnosticStepModel;
  isLoading?: boolean;
  error?: any;
}

export const initialState: SelfDiagnosticStepState = adapter.getInitialState({
  selected: null,
  isLoading: false,
  error: null,
});
